import { ApiService } from '../common/serviceBase';
import { URL_REPORTS } from '../common/apiUrl';

export class RelversoesService {
    constructor() {
        this.service = new ApiService(`${URL_REPORTS}/relatorios/relmodelos/relversoes`);
    }

    async getAll(relm_id) {
        const response = await this.service.get(relm_id + "/all");
        return response.data;
    }

    async create(data) {
        const response = await this.service.post('', data);
        return response.data;
    }

    async remove(relm_id) {
        const response = await this.service.delete(relm_id);
        return response;
    }

    async get(relm_id) {
        const response = await this.service.get(relm_id);
        return response.data;
    }
}